import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = {role: ROLE.SUPER_ADMIN};

const path = "admin/dashboard"


export const Counts = async () => {
    return await axiosInstance(options).get(`${path}/counts`);
}
export const Transactions = async (value) => {
    return await axiosInstance(options).post(`${path}/list-transactions`, value);
}

export const recentEarningList = async (value) => {
    return await axiosInstance(options).post(`${path}/recent-earning-list`, value);
}

